export type Input<T = unknown> = {
  value: T;
  hasChanged?: boolean;
  isValid: boolean;
};

export const RECOMMENDATION_KIND_ANOMALY = "anomaly";
export const RECOMMENDATION_KIND_DEFAULT = "recommendation";
